// extracted by mini-css-extract-plugin
export default {"monitoring-queue-table":"monitoringQueueTable_monitoring-queue-table__8tHuy"};